/**
 * LiveTotalsBar — totales vivos del panel derecho de Producción.
 *
 * Decisiones de diseño:
 * - Barra pegajosa (sticky) al pie del panel de trabajo: el operador nunca
 *   pierde de vista el total mientras edita (meta de 3 encomiendas/hora).
 * - El tramo de impuesto por paquete usa calcPackageTax (Tier 1,
 *   src/utils/customsCalc.js) — la misma fórmula por paquete del backend;
 *   aquí NUNCA se reimplementa la matemática.
 * - Solo totales: los CTA viven en Produccion.jsx (un solo dueño de acciones).
 * - Números en fuente mono para lectura de columna; actualiza en cada render
 *   (los paquetes llegan por props, sin estado propio).
 */
import { packageCrossesDai } from '../../utils/customsCalc';

const LiveTotalsBar = ({ packages = [], customsConfig }) => {

  let articulos = 0;
  let granTotal = 0;
  let con30 = 0;
  let soloIva = 0;

  for (const pkg of packages) {
    const items = pkg.items || [];
    articulos += items.length;
    granTotal += items.reduce(
      (s, it) => s + (parseFloat(it.unit_value) || 0) * (parseInt(it.quantity) || 1),
      0
    );
    const conDai = packageCrossesDai(items, customsConfig);
    if (conDai === true) con30 += 1;
    else if (conDai === false) soloIva += 1;
  }

  return (
    <div
      className="flex flex-wrap items-center justify-between gap-x-4 gap-y-1 border-t px-3 py-2"
      style={{ background: 'var(--tile)', borderColor: 'var(--border)' }}
      aria-label="Totales de la encomienda"
      role="status"
    >
      <span className="text-xs" style={{ color: 'var(--text-secondary)' }}>
        {packages.length} {packages.length === 1 ? 'paquete' : 'paquetes'} · {articulos}{' '}
        {articulos === 1 ? 'artículo' : 'artículos'}
      </span>
      <span className="text-xs" style={{ color: 'var(--text-secondary)' }}>
        {con30} con impuesto 30% · {soloIva} solo IVA
      </span>
      <span
        className="font-mono text-sm font-bold"
        style={{ color: 'var(--text-main)' }}
        aria-label={`Total declarado: ${granTotal.toFixed(2)} dólares`}
      >
        USD$ {granTotal.toFixed(2)}
      </span>
    </div>
  );
};

export default LiveTotalsBar;

/*
Ejemplo de uso (dentro del pie pegajoso de Produccion):
  <LiveTotalsBar
    packages={draft.packages}
    customsConfig={draft.customs_config_snapshot}
  />
*/
